module.exports = __webpack_public_path__ + "static/media/sortIcon.6d8632c4.svg";